import { createConnectQueryKey, useMutation } from '@connectrpc/connect-query'
import { useQueryClient } from '@tanstack/react-query'

import { toaster } from '@enechain/ecloud-designsystem'

import { saveMember } from '~/gen/proto/bff/v1/admin-BffAdminService_connectquery'
import { BffAdminService } from '~/gen/proto/bff/v1/admin_pb'
import { BffCommonService } from '~/gen/proto/bff/v1/common_pb'

export function useMemberMutation(
  onSuccess: () => void,
  memberId: string,
): ReturnType<typeof useMutation> {
  const queryClient = useQueryClient()
  return useMutation(saveMember, {
    onError: (error) => {
      toaster.create({
        title: error.message,
        type: 'error',
      })
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [
          createConnectQueryKey({
            schema: BffCommonService.method.listMembers,
            cardinality: 'finite',
          }),
          createConnectQueryKey({
            schema: BffCommonService.method.getMemberProfile,
            cardinality: 'finite',
          }),
        ],
      })
      void queryClient.refetchQueries({
        queryKey: createConnectQueryKey({
          schema: BffAdminService.method.getMember,
          input: { memberId: memberId },
          cardinality: 'finite',
        }),
      })
      onSuccess()
    },
  })
}
